import useSWR from 'swr'

export interface CountryDataType{
    id: number,
    country_name: string,
    country_name_en: string,
    region_id: number,
    country_code2: string,
    country_code3: string,
    dropdown_disp: string,
    target_year: number
}

/**
 * 国マスタを取得する
 */
export function useCountryData() {

    const fetchAddress = `/competition/api/master/countrydata`;
    // const fetchAddress = `http://localhost:3100/countrydata`;

    const fetcher = () => fetch(fetchAddress).then(res => 
        res.json()
    ).then(data => {
        return data.data;
    })

    const {data, error, isLoading, mutate} = useSWR(`CountryData`, fetcher, {revalidateOnFocus:false, revalidateOnReconnect:false});

    return{
        CountryData: data,
        isLoadingCountryData: isLoading,
        isError: error,
        mutate,
    }
}